import { mfaType } from '../types';

export const MFA_TYPE = {
  SMS: 'SMS' as mfaType,
  EMAIL: 'EMAIL' as mfaType,
  VOICE: 'VOICE' as mfaType,
};

export const newUser = {
  customerId: '',
  status: '',
  loginResponseCustomData: {
    mfaDestination: MFA_TYPE.SMS,
    needToConvert: false,
    stateToken: '',
  },
  mfaDestination: '',
  mfaType: MFA_TYPE.SMS,
  allowEmailResend: false,
  allowSmsResend: true,
  allowVoiceResend: false,
  firstLogin: true,
  authData: {
    accessToken: '',
    refreshToken: '',
  },
};
